import TextInput from '../../widgets/components/Input/TextInput'
import {useIntl} from 'react-intl'
import {Field, FormikProps} from 'formik'
import CustomSearchSelectInput from '../../widgets/components/Input/CustomSearchSelectInput'
// import {TemplateTypeOptions} from '../core/_constants'
import {TemplateFormValues} from '../core/_models'
import {ToolTipUIForModal} from '../../widgets/components/UI/ToolTipUIForModal'
import {DigitalSigningFilter} from '../core/_constants'

const TemplateForm = ({formik}: {formik: FormikProps<TemplateFormValues>}) => {
  const {formatMessage} = useIntl()
  const {TemplateTypeOptions} = DigitalSigningFilter()
  return (
    <div>
      <div className='mt-10'>
        <div className='d-flex gap-4 flex-wrap flex-md-nowrap'>
          <div className='w-100 w-md-50'>
            <TextInput
              isDisabled={false}
              fieldName={'templateName'}
              fieldType={'text'}
              formik={formik}
              isTooltipForModal={true}
              toolTipText={formatMessage({id: 'Please mention the title of the Template.'})}
              placeholder={formatMessage({id: 'Enter the Template Name'})}
              label={formatMessage({id: 'Template Name'})}
              isStarRequired={true}
              isMargin='mb-3'
            />
          </div>
          <div className='mb-3 w-49 w-full-mobile mb-5 mb-md-0'>
            <div className='d-flex'>
              <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                {formatMessage({id: 'Template Type'})}*
              </label>
              <ToolTipUIForModal
                tooltipText={formatMessage({
                  id: 'Please select the type of the template which you have to create',
                })}
              />
            </div>
            <Field
              name='templateType'
              component={CustomSearchSelectInput}
              options={TemplateTypeOptions}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TemplateForm
